<template>
  <div class="deviceUpgradeTask-detail">
    <div class="main">
      <div class="list">
        <div class="name-label">任务编号：</div>
        <div class="value-label width='80px'">{{ detail.number }}</div>
        <div class="name-label">创建时间：</div>
        <div class="value-label width='80px'">{{ detail.createTime }}</div>
        <div class="name-label">升级开始时间：</div>
        <div class="value-label width='80px'">{{ detail.startTime }}</div>
        <div class="name-label">升级设备类型：</div>
        <div class="value-label width='80px'">{{ detail.deviceTypeStr }}</div>
      </div>
      <div class="list">
        <div class="name-label">任务状态：</div>
        <div class="value-label" width='80px'>{{ detail.statusStr }}</div>
        <span class="ml10">升级指令状态：</span>
        <el-select
          class="fixed-width-100"
          size="mini"
          v-model="status">
          <el-option
            v-for="(item,key) in statusList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
      </div>
      <div class="list"></div>
      <table class="table-custom">
        <thead>
        <tr>
          <th>序号</th>
          <th>升级设备类型</th>
          <th>通讯版编号</th>
          <th>升级指令状态</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="item,index in dataList" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ item.deviceTypeStr }}</td>
          <td>{{ item.communicationBoardNo }}</td>
          <td>{{ item.statusStr }}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="4">暂无数据</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>

export default {
  name: "deviceUpgradeTaskDetailView",
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    editData: {
      handler() {
        this.detail = this.editData;
        this.number = this.editData.number;
        this.status = this.status;
        this.queryDeviceUpgradeTaskItem();
      },
    }
  },
  data() {
    return {
      number: '',
      status: '',
      statusList: [
        {
          id: '',
          name: '全部'
        }, {
          name: "待发送",
          id: 0
        },
        {
          name: "接收成功",
          id: 1
        },
        {
          name: "接收失败",
          id: 2
        }
      ],
      detail: {},
      dataList: []
    };
  },
  methods: {
    queryDeviceUpgradeTaskItem
      () {
      let self = this;
      let params = {
        number: this.number,
        status: this.status
      };
      this.$http.post('/managementPlatform/admin/queryDeviceUpgradeTaskItem', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.dataList = res.ldata;
      }).catch(function (response) {
        console.log(response);
      });
    },
    onQueryBtnClick() {
      this.dataList = [];
      this.queryDeviceUpgradeTaskItem();
    }
  }
};
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}

.table-custom {
  tbody {
    height: 600px;
    overflow-y: auto;
  }

  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #bee6b3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}

.ml-10 {
  margin-left: 10px;
}

.w-100 {
  width: 100px;
}

.mt4 {
  margin-top: 4px;
}

.mt-10 {
  margin-top: 10px;
}

.name-label {
  float: left;
}

.value-label {
  float: left;
  width: 17%;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/deviceUpgradeTaskDetailView.vue